import React, { useState } from 'react'
import { useCreatePlace } from '../../../context/CreatePlaceContext';
import Button from '../../shared/Button'
import Map from '../../shared/Map'

const Create3part2 = ({prevStep,nextStep}) => {
  const [markerPos, setMarkerPos] = useState(null);
  const { updatePlaceDetail, createInfoData } = useCreatePlace();

  const gotonext =()=>{
    updatePlaceDetail("stepFour", {
      lat:markerPos.lat,
      lng:markerPos.lng
    });
    nextStep()
  }
  return (
    <div>
      <Map markerPos={markerPos} setMarkerPos={setMarkerPos}/>
      <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
       <Button
                varient="gray"
                onClick={() => {
                  prevStep()
                }}
              >
                مرحله قبلی
              </Button> 

              <Button varient="primary" onClick={gotonext}>
                  مرحله بعدی
              </Button>
            </div>
    </div>
  )
}

export default Create3part2